import {
  Component,
  Input,
  OnInit,
  ViewChild,
  TemplateRef,
  signal,
  computed,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { IPaymentsList } from 'src/app/@interfaces/payments.interface';
import { IMailList } from 'src/app/@interfaces/lists.interface';
import { CrudBanksComponent } from '../crud-banks/crud-banks.component';
import { CrudCashiersComponent } from '../crud-cashiers/crud-cashiers.component';
import { CrudMailsComponent } from '../crud-mails/crud-mails.component';
import { VOneTabsComponent, VOneIconComponent } from '@shared-components';
import { VOneTab } from '@shared-models';

// Header title keys reuse the existing flat translation entries already
// shown by each child's own <h2> (see 'Bank List' / 'Cashiers List' /
// 'Mails List' in assets/i18n) so the unified header says the same thing
// each standalone modal used to say for that list.
const HEADER_TITLE_KEYS: Record<string, string> = {
  cashiers: 'Cashiers List',
  banks: 'Bank List',
  mails: 'Mails List',
};

@Component({
  selector: 'app-crud-payment-lists',
  templateUrl: './crud-payment-lists.component.html',
  styleUrls: ['./crud-payment-lists.component.css'],
  imports: [
    MatDialogModule,
    VOneTabsComponent,
    VOneIconComponent,
    CrudBanksComponent,
    CrudCashiersComponent,
    CrudMailsComponent,
    TranslatePipe,
  ],
})
export class CrudPaymentListsComponent implements OnInit {
  @Input() listBanks: Array<IPaymentsList> = [];
  @Input() listCashiers: Array<IPaymentsList> = [];
  @Input() listMails: Array<IMailList> = [];
  @Input() group: string = '';
  @Input() initialTabId: string = 'cashiers';

  @ViewChild('cashiersTab', { static: true })
  cashiersTab!: TemplateRef<unknown>;
  @ViewChild('banksTab', { static: true }) banksTab!: TemplateRef<unknown>;
  @ViewChild('mailsTab', { static: true }) mailsTab!: TemplateRef<unknown>;

  tabs = signal<VOneTab[]>([]);
  activeTabId = signal<string>('cashiers');

  readonly headerTitleKey = computed(
    () => HEADER_TITLE_KEYS[this.activeTabId()] ?? '',
  );

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.activeTabId.set(this.initialTabId);
    this.tabs.set([
      {
        id: 'cashiers',
        label: this.translate.instant('global.paymentLists.tabCashiers'),
        content: this.cashiersTab,
      },
      {
        id: 'banks',
        label: this.translate.instant('global.paymentLists.tabBanks'),
        content: this.banksTab,
      },
      {
        id: 'mails',
        label: this.translate.instant('global.paymentLists.tabMails'),
        content: this.mailsTab,
      },
    ]);
  }

  onTabChange(tabId: string): void {
    this.activeTabId.set(tabId);
  }
}
